(function(angular) {
    'use strict';

    angular.module('app')
        .controller('homeController', ['$scope', 'portalConfig', '$uibModal', '$rootScope', 'permissionService', function ($scope, portalConfig, $uibModal, $rootScope, permissionService) {
        
        $scope.tutorials = true;
        $scope.serviceOverview = false;
        $scope.editingApiSpace = permissionService.checkPermission("apis:w");  

        $scope.addApiSpace = function(){
            $rootScope.$broadcast("apiSpace:add");
        };
      
        $scope.openFilm = function (link) {

           $uibModal.open({
                animation: true,
                templateUrl: 'partials/filmModal.html',
                controller: 'filmController',
                size: 'extralg',
                resolve: {
                    link: function(){
                        return link;
                    }
                }
            });

        };
    }])
    .controller('filmController', ['$scope', 'link', '$sce', function($scope, link, $sce){
        $scope.link = $sce.trustAsResourceUrl(link + '?autoplay=1&modestbranding=1&showinfo=0&rel=0');
        //$scope.width =  window.innerWidth + 'px';
        //$scope.height =  window.innerHeight + 'px';
    }]);

})(window.angular);
